import React from 'react';
import styles from './WelcomeStep.module.css';

const WelcomeStep = ({ onStart }) => {
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.logoSection}>
          <span className={styles.logo}>KAMUYOT</span>
        </div>

        <h1 className={styles.title}>ברוכים הבאים!</h1>

        <p className={styles.description}>
          בכמה שלבים קצרים נגדיר יחד את הפרויקט שלך.
          <br />
          נשאל כמה שאלות על הבית, הקומות והחללים — ובסוף תקבל:
        </p>

        <ul className={styles.benefitsList}>
          <li>
            <span className={styles.benefitIcon}>📊</span>
            <span>מודל עלויות מותאם לפרויקט שלך</span>
          </li>
          <li>
            <span className={styles.benefitIcon}>📋</span>
            <span>כתב כמויות מוכן לעבודה</span>
          </li>
          <li>
            <span className={styles.benefitIcon}>💰</span>
            <span>כלי ניהול תקציב חכם</span>
          </li>
          <li>
            <span className={styles.benefitIcon}>🏠</span>
            <span>מעקב אחרי כל חלל, פריט וספק</span>
          </li>
        </ul>

        <p className={styles.reassurance}>זה ייקח כמה דקות בלבד, וכל מה שתזין אפשר לשנות בהמשך.</p>

        <button className={styles.startButton} onClick={onStart}>
          בואו נתחיל ←
        </button>
      </div>
    </div>
  );
};

export default WelcomeStep;
